import classNames from 'classnames';
import { Avatar as FoldsAvatar } from 'folds';
import React, { forwardRef } from 'react';
import { Silhouette, SilhouetteProps, Shape } from '../silhouette';
import { silhouetteFill } from '../silhouette/Silhouette.css';

export { Shape as AvatarShape } from '../silhouette';

export function roomAvatarShape(direct?: boolean): Shape {
  return direct ? Shape.Circle : Shape.Squircle;
}

export type AvatarProps = SilhouetteProps;

export const Avatar = forwardRef<HTMLElement, AvatarProps>(function Avatar(
  { shape, className, size, as = 'span', children, style, ...props },
  ref
) {
  const sized =
    size !== undefined || style?.width !== undefined || style?.height !== undefined;

  return (
    <Silhouette
      as={as}
      shape={shape}
      size={size}
      className={className}
      style={style}
      ref={ref}
      {...props}
    >
      <FoldsAvatar radii="Inherit" size={size} className={classNames(sized && silhouetteFill)}>
        {children}
      </FoldsAvatar>
    </Silhouette>
  );
});
